"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFuntion = function (arg) { return typeof arg === 'function'; };
exports.isString = function (arg) { return Object.prototype.toString.call(arg) === '[object String]'; };
exports.isNumber = function (arg) { return Object.prototype.toString.call(arg) === '[object Number]'; };
exports.isDate = function (arg) { return Object.prototype.toString.call(arg) === '[object Date]'; };
exports.isArray = function (arg) { return Object.prototype.toString.call(arg) === '[object Array]'; };
exports.isBoolean = function (arg) { return Object.prototype.toString.call(arg) === '[object Boolean]'; };
exports.isObject = function (arg) { return Object.prototype.toString.call(arg) === '[object Object]'; };
function captitalize(str) {
    if (!exports.isString(str)) {
        return '';
    }
    return "" + str.charAt(0).toUpperCase() + str.slice(1);
}
exports.captitalize = captitalize;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/helper/utils.js
// module id = 17
// module chunks = 0